<template>
  <div
    :class="$b({
      active: scrollPercentage > 10,
      visibleOnDesktop
    })"
    @click="$emit('back-to-top')"
  >
    <div :class="$b('inner')">
      <svg :class="$b('circle-svg')">
        <circle
          ref="svgcircle"
          cx="21"
          cy="21"
          r="19"
          :class="$b('circle', { fill: true })"
          stroke="url('#IconGradient')"
          :stroke-dashoffset="svgPos"
          :stroke-dasharray="svgLength"
        />
        <defs>
          <linearGradient
            id="IconGradient"
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(20)"
          >
            <stop
              offset="0"
              stop-color="#5C0F99"
            />
            <stop
              offset="60%"
              stop-color="#3449B8"
            />
            <stop
              offset="100%"
              stop-color="#1799E1"
            />
          </linearGradient>
        </defs>
      </svg>

      <VisionIcon
        icon="chevron"
        size="x-small"
        colour="black"
        :class="$b('back-to-top-icon')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',

  props: {
    scrollPercentage: {
      type: Number,
      required: true
    },
    visibleOnDesktop: {
      type: Boolean,
      default: false
    }
  },

  emits: ['back-to-top'],
  data: () => ({
    svgLength: 0,
    svgPos: 0
  }),
  watch: {
    scrollPercentage () {
      this.svgPos = this.updateProgress()
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.svgcircle) {
        this.svgLength = Math.ceil(this.$refs.svgcircle.getTotalLength())
        this.svgPos = this.svgLength
      }
    })
  },
  methods: {
    updateProgress () {
      const scrollPercentageLimit = Math.min(this.scrollPercentage, 100)
      const svgOffset = this.svgLength / 100 * scrollPercentageLimit
      
      return Math.ceil(this.svgLength - svgOffset)
    }
  }
}
</script>

<style lang="postcss">
.BackToTop {
  @apply sticky
    flex items-center justify-center
    cursor-pointer
    overflow-hidden pt-xxs;
  
  bottom: 0;
  width: 42px;
  margin-left: auto;
  margin-right: theme('spacing.sm');
  z-index: 3;

  &:not(&--visible-on-desktop) {
    @apply md:opacity-0
  }
}

.BackToTop__inner {
  @apply relative
    rounded-full
    transition-transform;
  
  margin-bottom: theme('spacing.sm');
  transition-duration: 400ms;
  transform: translate3d(0, 200%, 0);

  .BackToTop--active & {
    transform: translate3d(0, 0%, 0);

    &:hover {
      transform: translate3d(0, -5%, 0);
    }
  }
}

.BackToTop__circle-svg {
  @apply relative;
  width: 42px;
  height: 42px;
  transform: rotate(-90deg);
}

.BackToTop__circle {
  fill: theme('colors.grey-light');
  stroke-linecap: butt;
  stroke-opacity: 1;
  stroke-width: 2;
}

.BackToTop__back-to-top-icon {
  @apply absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0) rotate(270deg)
}
</style>
